/**
 * Build a user-visible message from a Netlify function JSON error body.
 * Functions may attach `hint` (e.g. OpenAI / env setup).
 */
export function getFriendlyApiError(data, fallback = "") {
  if (!data || typeof data !== "object") return fallback || "Unable to complete request.";
  const err = typeof data.error === "string" ? data.error : "Request failed";
  if (typeof data.hint === "string") return `${err}: ${data.hint}`;
  return err;
}
